"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidFileType = void 0;
const isValidFileType = (fileType) => {
    const validTypes = [
        "commercialInvoice",
        "packingList",
        "inlandBillOfLading",
        "consignmentNote",
        "deliveryReceipts",
        "policeReport",
        "reeferTempLog",
        "fireReport",
        "photos"
    ];
    return validTypes.includes(fileType);
};
exports.isValidFileType = isValidFileType;
//# sourceMappingURL=index.js.map